/* eslint-disable */
import { BiPencil } from "react-icons/bi";
import { SiMongodb } from "react-icons/si";
import { MdDesignServices } from "react-icons/md";
import { BsCodeSlash, BsServer } from "react-icons/bs"
import { FaInternetExplorer, FaRegNewspaper, FaReact, FaNodeJs } from "react-icons/fa";


export const servicesData = [

    {
        id: 6,
        title: 'Fullstack Website',
        icon: <BsCodeSlash />
    },
    {
        id: 1,
        title: 'Frontend Design',
        icon: <FaReact />
    },
    {
        id: 3,
        title: 'Database',
        icon: <SiMongodb />
    },
    {
        id: 5,
        title: 'Server',
        icon: <BsServer />
    },
    {
        id: 4,
        title: 'Internet Research',
        icon: <FaInternetExplorer />
    },
    {
        id: 10,
        title: 'NodeJS',
        icon: <FaNodeJs />
    },
    {
        id: 11,
        title: 'Modern UI Design',
        icon: <MdDesignServices />
    },
    {
        id: 13,
        title: 'Blog Posting',
        icon: <FaRegNewspaper />
    },
    {
        id: 2,
        title: 'Content Management',
        icon: <BiPencil />
    },

]

